import { Button } from "@components/atoms/Button"
import { ShareButton } from "@components/atoms/ShareButton"
import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Button",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/button", (props) => {
  const El = props.type === "share" ? ShareButton : Button
  const elProps = {
    ...{
      href: props.link?.url || "",
      target: props.link?.target || "_self",
    },
    ...(props.type === "share" ? { shareTitle: props.link?.title!, shareUrl: props.link?.url! } : {}),
  }

  return (
    <El {...elProps}>
      <p className="flex items-center justify-center gap-2">
        <span>{props.link?.title || (props.type === "share" ? "Share" : "Button")}</span>
        {(props.type === "share" || props.link?.target === "_blank") && <span>↗</span>}
      </p>
    </El>
  )
})
